import React from "react";
import { FollowUpContractsView } from "../../views";
import {
  TemplateService,
  LocalStorageService,
  FollowupContractsService,
  WorkflowService
} from "../../../services/index";
import { NIL as NIL_UUID } from "uuid";
// import { setTimeout } from "timers/promises";
import moment from "moment"
import { getNavigatorTimezone } from "../../../utils";
class FollowUpContractsAction extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      clientTemplates: [],
      onNewTemplate: false,
      onEdit: false,

      loading: false,
      shouldRefresh: false,
      token: "",
      companies: [],
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      message: "",
      clientId: 0,

      questionnaires: [],
      lawyers: [],
      companies: [],
      users: [],
      contractStatus: [],
      filterCompany: [],

      disableLawyer: false,
      disableUser: false,
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  templateService = new TemplateService(this.url);
  localStorageService = new LocalStorageService();
  followUpContractsService = new FollowupContractsService(this.url)
  workflowService = new WorkflowService(this.url);
  timezone = getNavigatorTimezone()

  async componentDidMount() {
    let ENV = process.env
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user")
    let clientId = this.user.userMetaData.userA3Cloud.clientId
    let userType = this.user.userMetaData.userRoles
    let lawyerId = ''
    let userId = ''
    try {
      let followupContracts = await this.followUpContractsService.getContractMonitoring(this.token)

      if (!(Number(followupContracts.statusCode) === 200)) {
        this.setState({
          loading: false,
        })

        await this.toggleErrorRequesting(true, 'Ocurrio un error en al obtener contratos.', 600000)

        // throw new Error('No se pudo cambiar la contraseña del usuario')
      }

      userType.map((type) => {
        if ([ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER, ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER_AUTH].includes(type.role.key)) {
          this.setState({
            disableLawyer: true
          })
          lawyerId = this.user.userMetaData.userMifirma.id
        }
        if (type.role.key === ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_APPLICANT) {
          this.setState({
            disableUser: true
          })
          userId = this.user.userMetaData.userMifirma.id
        }
      })

      let filterCompany = await this.followUpContractsService.getContractFilter(this.token, lawyerId, userId, '', '', this.timezone)
      filterCompany[0].clientContract.map((company) => {
        company.html = `<div class="gridHLPure-containerLabel" style="line-height: 18px;"><span style="font-size: 18px; padding-top: 10px">${company.name}</span><div class="gridHLPure-detailsContainer"><span style="font-weight: 300;">${company.description}</span></div><div class="gridHLPure-detailsContainer"><span style="font-weight: 300;">${company.updatedDate}</span></div></div>`
        company.notifyBtn = (company.workflowStatusCurrent === Number(ENV.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102620)) ? true : false
      })

      //Inicializar Dropdown Empresas 
      let statusContracts = [{
        countWorkflowExecution: NIL_UUID,
        workflowExecutionName: 'Todos los Estatus'
      }]

      filterCompany[0].workflowStatus.map((workflow, index) => {
        statusContracts.push(workflow)
      });

      statusContracts = statusContracts.filter((status) => {
        let hiddenStatuses = [
          "negociando", "negociado", "firmando", "firmado", "almacenado", "resguardo"
        ]
        return !hiddenStatuses.includes(status.workflowExecutionName.toLowerCase());
      })

      //Inicializar Dropdown Empresas 
      let companies = [{
        companyId: '1',
        name: 'Todas las Empresas'
      },
      {
        companyId: NIL_UUID,
        name: 'Sin empresa asignada'
      }
      ]

      followupContracts.data[0].userRoleCompany.map((company, index) => {
        // company.name = `${company.company.businessName}`
        // companies.push(company)
        let Newcompany = []
        Newcompany.name = `${company.company.businessName}`.substring(0, 35)
        Newcompany.companyId = `${company.companyId}`

        companies.push(Newcompany)
      });

      //Inicializar Dropdown Tipos de contratos
      let questionnaires = [{
        id: NIL_UUID,
        name: this.props.t("digitalContractHomeView.main.allTypesContracts")
      }]
      // let questionnaires = []
      followupContracts.data[0].questionnaire.map((questionnaire, index) => {
        questionnaire.name = `${questionnaire.name}`.substring(0, 35)
        questionnaires.push(questionnaire)
      });

      //Inicializar Dropdown abogados
      let userRole = []
      if (this.state.disableLawyer !== true) {
        userRole = [{
          userId: NIL_UUID,
          name: 'Todos los Abogados'
        }]
      }

      followupContracts.data[0].userRole.map((abogado) => {
        abogado.name = `${abogado.user.firstName} ${abogado.user.firstLastName} ${abogado.user.secondLastName}`.substring(0, 35)

        userRole.push(abogado)
      });



      //Inicializar Dropdown solicitantes
      let userRoleUsers = []
      if (this.state.disableUser !== true) {
        userRoleUsers = [{
          userId: NIL_UUID,
          name: 'Todos los Solicitantes'
        }]
      }

      followupContracts.data[0].userRoleUsers.map((solicitante) => {
        if (solicitante.user.firstName.replace(/\s/g, '') !== ' ' && solicitante.user.firstName.replace(/\s/g, '') !== '') {
          solicitante.name = `${solicitante.user.firstName} ${solicitante.user.firstLastName} ${solicitante.user.secondLastName}`.substring(0, 35)
          userRoleUsers.push(solicitante)
        }
      });

      let totalPercert = `${parseFloat(filterCompany[0].percentageContractsDelivered).toFixed(0)}%`
      this.setState({
        loading: false,
        token: this.token,
        clientId: clientId,

        questionnaires: questionnaires,
        lawyers: userRole,
        companies: companies,
        users: userRoleUsers,
        contractStatus: statusContracts,

        filterCompany: filterCompany[0].clientContract,
        totalContract: filterCompany[0].countTotalContracts,
        totalPercentCotract: totalPercert
      })

    } catch (error) {
      console.error(error);
      this.props.history.push("/");
      return;
    }

  }


  async componentDidUpdate(prevProps, prevState) {
    if (prevState.shouldRefresh !== this.state.shouldRefresh) {
      this.getUserCollaboratorsAdmin();
    }
  }


  getNewContracts = async (dateStart, dateEnd) => {
    let ENV = process.env
    let followUpContractsService = new FollowupContractsService(process.env.REACT_APP_MIFIRMA_API)
    let localStorageService = new LocalStorageService()

    let paramDateStart = moment(dateStart).format('DD-MM-YYYY')
    let paramDateLimit = moment(dateEnd).format('DD-MM-YYYY')

    try {

      let token = localStorageService.getLocalStorageItem("token").idToken;
      let user = localStorageService.getLocalStorageItem("user")
      let userType = user.userMetaData.userRoles
      let lawyerId = ''
      let userId = ''

      userType.map((type) => {
        if ([ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER, ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER_AUTH].includes(type.role.key)) {
          lawyerId = user.userMetaData.userMifirma.id
        }
        if (type.role.key === ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_APPLICANT) {
          userId = user.userMetaData.userMifirma.id
        }
      })

      let response = await followUpContractsService.getContractFilter(token, lawyerId, userId, paramDateStart, paramDateLimit, this.timezone)

      response[0].clientContract.map((company) => {
        company.html = `<div class="gridHLPure-containerLabel" style="line-height: 18px;"><span style="font-size: 18px; padding-top: 10px">${company.name}</span><div class="gridHLPure-detailsContainer"><span style="font-weight: 300;">${company.description}</span></div><div class="gridHLPure-detailsContainer"><span style="font-weight: 300;">${company.updatedDate}</span></div></div>`
        company.notifyBtn = (company.workflowStatusCurrent === Number(ENV.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102620)) ? true : false
      })

      let totalPercert = `${parseFloat(response[0].percentageContractsDelivered).toFixed(2)}%`

      this.setState({
        filterCompany: response[0].clientContract,
        totalContract: response[0].countTotalContracts,
        totalPercentCotract: totalPercert
      })

      return response
    } catch (error) {

    }
  }

  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleCompletedRequesting = (value, message, templates) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
            clientTemplates: templates,
          });
          // funcion()
        }, 4000);
      }
    );
  };

  toggleErrorRequesting = async (value, message, time) => {
    this.setState(
      {
        showErrorRequesting: value,
        message: message
      },
      () => {
        setTimeout(() => {
          this.setState({
            showErrorRequesting: false,
            message: ''
          });
        }, time || 4000);
      }
    );
  };

  sendToNextPage = async (solicitudeId) => {
    this.toggleLoadingRequesting(true)
    try {
      let workflowInfo = await this.workflowService.getWorkflowBySolicitudeIdAndWorkflowId(solicitudeId, 4, this.token)
      if (workflowInfo && workflowInfo.data && Number(workflowInfo.statusCode) === 200) {
        let statusContract = workflowInfo.data.worflowStatus.statusType
        if (workflowInfo && statusContract && statusContract === process.env.REACT_APP_STATUS_END) {
          let workflowNegotiation = await this.workflowService.getWorkflowBySolicitudeIdAndWorkflowId(solicitudeId, 6, this.token)
          if (workflowNegotiation && workflowNegotiation.data && workflowNegotiation.data.workflowStatusCurrent && (workflowNegotiation.data.workflowStatusCurrent === Number(process.env.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102605) || (workflowNegotiation.data.workflowStatusCurrent === Number(process.env.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102610)))) {
            let workflowExcecutionIdNego = workflowNegotiation.data.id
            this.props.history.push(`/negotiate-contract/${solicitudeId}/${workflowExcecutionIdNego}`);
          } else {
            this.props.history.push(`/contract-request-status/${solicitudeId}`);
          }
        } else {
          let workflowExcecutionId = workflowInfo.data.id
          this.props.history.push(`/followup-actions-contracts/${solicitudeId}/${workflowExcecutionId}`);
        }
      } else {
        this.props.history.push("/");
      }
    } catch (error) {
      console.error(error);
      this.props.history.push("/");
    }
  }

  render() {
    return (
      <FollowUpContractsView
        {...this.state}
        view={this.props.match.params}
        forceRefresh={this.forceRefresh}
        getNewContracts={this.getNewContracts}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        sendToNextPage={this.sendToNextPage}
      />
    );
  }
}
export { FollowUpContractsAction as default };